<template>
  <div :class="[companyClass, canScroll]" v-show="userPermissionsFilter.addexchangerates">
    <div class="page-exchangerates flex column mb-20">
      <div class="page-header">
        <h1 class="pageTitle">Uploaded Exchange Rates</h1>
        <h4>exchange rates uploaded list</h4>
        <div id="plug">
          <div v-if="showTimer" class="v" style="color:red">We are moving this module to <a :href=newbackofficeurl
              target="_blank">New
              Backoffice</a>. This module will be permanently disabled in {{ timerOutput }}</div>
          <div v-else class="v"></div>
        </div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
          <el-breadcrumb-item>settings</el-breadcrumb-item>
          <el-breadcrumb-item>uplaoded exchange rates</el-breadcrumb-item>
          <el-breadcrumb-item>view ex-rates</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="mt-0">
        <div style="float: right">
          <el-button v-show="userPermissionsFilter.deleteexchangerates" type="danger" icon="el-icon-delete"
            @click="openDialog(2)">Reject</el-button>
          <el-button v-show="userPermissionsFilter.addexchangerates" type="primary" icon="el-icon-check"
            @click="openDialog(1)">Approve</el-button>
        </div>
      </div>

      <div class="toolbar-box flex">
        <div class="search-box box grow">
          <div><i class="mdi mdi-magnify"></i></div>
          <input v-model="search" placeholder="Search..." />
        </div>
        <div class="pagination-box animated fadeInRight">
          <div class="select-box">
            <el-select v-model="paginationInfo.pageSize" placeholder="Rows per page" size="mini">
              <el-option value="10" label="10"></el-option>
              <el-option value="15" label="15"></el-option>
              <el-option value="20" label="20"></el-option>
              <el-option value="30" label="30"></el-option>
              <el-option value="50" label="50"></el-option>
              <el-option value="100" label="100"></el-option>
            </el-select>
          </div>
          <div class="label">/page</div>
        </div>
        <div class="csv-box animated fadeInRight">
          <button @click="downloadData">download csv ({{ total }})</button>
        </div>
      </div>

      <resize-observer @notify="handleResize" />

      <div class="table-box card-base card-shadow--medium box grow" id="table-wrapper" v-loading="!asyncComponent">
        <div :style="{ width: width + 'px' }">
          <!-- v2-table -->
          <component :is="asyncComponent" ref="table" :data="list" :height="height" :border="false" :total="total"
            :lazy-load="false" :loading="loading" class="styled" :class="{ mobile: isMobile }"
            @page-change="handlePageChange" :pagination-info="paginationInfo"
            :default-sort="{ prop: sortingProp, order: sortingOrder }" @sort-change="handleSortChange"
            @select-change="handleSelectChange" :show-summary="showSummary" :shown-pagination="shownPagination">
            <v2-table-column type="selection" width="45"></v2-table-column>
            <v2-table-column label="From Currency" prop="fromCurrencyCodeName" sortable width="200" align="left"
              :fixed="isMobile ? '' : 'left'"></v2-table-column>
            <v2-table-column label="To Currency" prop="toCurrencyCodeName" sortable width="200" align="left"
              :fixed="isMobile ? '' : 'left'"></v2-table-column>

            <v2-table-column label="Exchange Rate" prop="rate" width="150" align="center" sortable></v2-table-column>
            <v2-table-column label="Country" prop="countryName" width="150" align="left" sortable></v2-table-column>
            <v2-table-column label="Starting On" prop="runningFromStr" width="200" align="center"
              sortable></v2-table-column>
            <v2-table-column label="Running To" prop="runningToStr" width="200" align="center" sortable
              :fixed="isMobile ? '' : 'right'"></v2-table-column>
            <v2-table-column label="Added On" prop="createdOnStr" sortable width="150" align="center"></v2-table-column>

            <v2-table-column label="Action" width="70" :fixed="isMobile ? '' : 'right'">
              <template slot-scope="row">
                <div class="custom-action-row">
                  <el-button @click="print(row)"><i class="mdi mdi-eye"></i></el-button>
                </div>
              </template>
            </v2-table-column>
          </component><!-- v2-table -->
        </div>
      </div>
    </div>

    <el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible" @close="closeDialog"
      :before-close="handleClose">
      <div class="form-box">
        <div class="row">
          <el-input placeholder="id" v-model="exchangeRateFileUploadViewModel.id" name="id" type="hidden"></el-input>
          <el-input placeholder="status" v-model="exchangeRateFileUploadViewModel.status" name="status"
            type="hidden"></el-input>
          <div class="row mt-12">
            <div class="col col-md-12">
              <el-input placeholder="remarks" v-model="exchangeRateFileUploadViewModel.remarks" name="remarks"
                v-validate="'required'" data-vv-as="Remarks" type="textarea"></el-input>
              <transition name="fade">
                <span class="danger-text">{{ errors.first("remarks") }}</span>
              </transition>
            </div>
          </div>
          <div class="row mt-12" v-show="userPermissionsFilter.approveexchangerates">
            <div class="col col-md-12">
              <el-button type="success" @click="validateAndSubmit" class="btn-group" style="width: 100%">
                <i class="mdi mdi-cancel"></i><span> Submit</span>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PermissionsMixins from "@/mixins/PermissionsMixins";
import router from "@/router/";

export default {
  name: "ExchangeRatesBulkUploadLists",
  data() {
    return {
      exchangeRateFileUploadViewModel: {
        id: "",
        remarks: "",
        status: "",
      },
      newbackofficeurl: "",
      countDownToTime: new Date('Oct 15, 2024 00:00:00').getTime(),
      timerOutput: '',
      showTimer: true
    };
  },
  methods: {
    openDialog(data) {
      this.dialogFormVisible = true;
      this.exchangeRateFileUploadViewModel.status = data;
      this.exchangeRateFileUploadViewModel.id = router.currentRoute.params.id;
    },
    addRate() {
      router.push("/addexchangerate");
    },
    validateAndSubmit() {
      let self = this;
      // console.log(self.exchangeRateFileUploadViewModel.status);
      // console.log(self.exchangeRateFileUploadViewModel.status);
      var formData = new FormData();
      formData.append("status", self.exchangeRateFileUploadViewModel.status);
      formData.append("remarks", self.exchangeRateFileUploadViewModel.remarks);
      formData.append("id", self.exchangeRateFileUploadViewModel.id);
      //console.log(formData);
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.authorizeExchangeRateBulkUpload(formData).then((result) => {
              console.log(result);
              if (result.item1 && result.item1 == true) {
                this.successMessage(result.item2);
                // this.clearState();
                // this.entitySaved();
                router.push("/exchangerates");
                this.dialogFormVisible = false;
              } else {
                this.errorMessage(
                  "Failed to authorize exchange rate, makes sure there are no other rates uploaded on the specified dates."
                );
              }
            });
          }
        })
        .catch((err) => console.log(err));
    },
    downloadData() {
      var id = router.currentRoute.params.id;
      this.getExchangeRateBulkUploads(
        id,
        this.currentPage,
        this.paginationInfo.pageSize
      )
        .then((result) => {
          if (result.items)
            this.downloadCSV(
              result.items.map((p) => {
                var c = {
                  From_Currency: p.fromCurrencyCodeName,
                  To_Currency: p.toCurrencyCodeName,
                  Rate: p.rate,
                  Country: p.countryName,
                  Running_From: p.runningFromStr,
                  Running_To: p.runningToStr,
                  CreatedOn: p.createdOnStr,
                };

                return c;
              })
            );
        })
        .catch((err) => this.errorMessage("Error downloading data."));
    },
    print(row) {
      router.push(`/updatebulkexchangerate/${row.id}`);
    },
    refreshExRates() {
      var id = router.currentRoute.params.id;
      this.getExchangeRateBulkUploads(
        id,
        this.currentPage,
        this.paginationInfo.pageSize
      )
        .then((result) => this.tableRefreshed(result))
        .catch((err) => this.tableRefreshed(this.defaultListResult));
    },
  },
  created() {
    this.startTimer();
    let self = this;
    this.newbackofficeurl = self.$newbackofficeurl;

    this.deleteEvent = "deactivateSelectedRates";
    this.refreshListEvent = "refreshExRates";
    this.$on(this.refreshListEvent, this.refreshExRates);
    this.$on(this.deleteEvent, this.deactivateSelectedRates);
    this.refreshExRates();
  },
  mixins: [PermissionsMixins],
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/_variables";

.page-exchangerates {
  &.overflow {
    overflow: auto;
  }

  .table-box {
    overflow: hidden;
  }
}
</style>
<style lang="scss">
@import "../../assets/scss/_variables";

.page-exchangerates {
  .custom-action-row {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .el-button {
      padding: 1px 5px;
    }
  }

  .toolbar-box {
    margin-top: 20px;

    .search-box {
      &>div {
        width: 20px;
        display: inline-block;
      }

      margin-bottom: 10px;

      i {
        display: inline-block;
        width: 22px;
      }

      input {
        outline: none;
        background: transparent;
        border: none;
        font-size: 15px;
        position: relative;
        padding: 0;
        margin-left: -20px;
        display: inline-block;
        padding-left: 20px;
        box-sizing: border-box;
        top: -1px;
        width: 100%;
        color: $text-color;
      }

      .icons-tot {
        margin-right: 20px;
      }
    }

    .pagination-box {
      width: 120px;
      margin: 0 15px;

      .select-box {
        width: 70px;
        display: inline-block;
      }

      .label {
        width: 50px;
        display: inline-block;
      }

      .el-input__inner {
        height: 22px;
        border: none;
        background: transparent;
        font-size: 16px;
        text-align: right;
        font-family: inherit;
        padding-right: 20px;
        color: $text-color;
      }

      .el-input__suffix {
        right: -3px;

        .el-select__caret {
          color: transparentize($text-color, 0.7);
        }
      }
    }

    a,
    button {
      padding: 0;
      margin: 0 15px;
      background: transparent;
      border: none;
      outline: none;
      font-family: inherit;
      font-size: inherit;
      cursor: pointer;

      border-bottom: 1px solid;
      text-decoration: none;
      color: $text-color;

      &:hover {
        opacity: 0.6;
      }
    }

    a {
      margin-right: 0;
    }
  }

  .sel-string {
    .sel {
      background: transparentize($text-color, 0.8);
      border-radius: 5px;
      text-transform: uppercase;
    }
  }
}

@media (max-width: 768px) {
  .page-exchangerates {
    .toolbar-box {
      display: block;
      overflow: hidden;
      font-size: 80%;

      &>* {
        display: inline-block;
        min-width: 120px;
        height: 22px;
        background: rgba(0, 0, 0, 0.04);
        padding: 4px;
        margin: 3px !important;
      }
    }
  }
}
</style>